const axios = require("axios");
const apiKey = "23a65aca-95bf-4296-8e2e-c00c908feac8";
const password = "0dfa2031-82e7-4ecc-9c68-ee59b9c6fe23";

const apiKey2 = "CD6D18D6-A05E-4211-B654-87A52C164B78";
const password2 = "00A272AA-F50D-42E1-B65B-FC51F05252C7";
import useJwt from "@/auth/jwt/useJwt";

const axiosGet = (url, params = null) => {
  let auth = "";
  try {
    auth = useJwt.getToken();
  } catch (e) {
    auth = "";
  }
  // Make a request for a user with a given ID
  //console.log("params", params);
  // EditorDom/GetById ไม่ต้องใส่ apiKey, password
  if (url.includes("EditorDom/GetById")) {
    return axios.get(url, {
      headers: { ApiKey: apiKey, Password: password },
      params,
    });
    /// เนื่องจาก digital-api ใช้แยกกันจะเช็คจาก url
  } else if (url.includes("/digital-api/")) {
    return axios.get(url, {
      params,
      headers: { id: apiKey2, clientId: password2 },
    });
  } else {
    return axios.get(url, {
      params,
      headers: { ApiKey: apiKey, Password: password, Auth: auth },
    });
  }
};

// get for file blob
const axiosGetBlob = (url, params = null) => {
  let auth = "";
  try {
    auth = useJwt.getToken();
  } catch (e) {
    auth = "";
  }
  return axios.get(url, {
    params,
    headers: { ApiKey: apiKey, Password: password, Auth: auth },
    responseType: "blob",
  });
};

const axiosPost = (url, params = null) => {
  let auth = "";
  /// เนื่องจาก digital-api ใช้แยกกันจะเช็คจาก url
  if (url.includes("/digital-api/")) {
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json",
        id: apiKey2,
        clientId: password2,
      },
    });
  }

  try {
    auth = useJwt.getToken();
  } catch (e) {
    auth = "";
  }
  return axios.post(url, params, {
    headers: {
      "Content-Type": "application/json",
      ApiKey: apiKey,
      Password: password,
      Auth: auth,
    },
  });
};

const axiosPostOAuth = (url, params, header) => {
  return axios.post(url, params, header);
};

const axiosGetOAuth = (url, params, header) => {
  return axios.get(url, params, header);
};

const axiosGetOAuth_V2 = (url, header) => {
  return axios.get(url, { headers: { client_id: header } });
};

export {
  axiosGet,
  axiosGetBlob,
  axiosPost,
  axiosPostOAuth,
  axiosGetOAuth,
  axiosGetOAuth_V2,
};
